import React, { useState } from "react";
import { favorit } from "../../../../utils/favoit";
import {
  Bottom,
  Box,
  Btn,
  Button,
  Container,
  Delate,
  Image,
  LeftArrow,
  Pagination,
  RightArrow,
  Title,
  TitleDiv,
  Top,
  Trash,
} from "./style";

const Favorites = () => {
  let pattern = null;
  const [post, setPost] = useState(favorit);
  const [page, setPage] = useState(1);
  const [countriesPerPage] = useState(3);
  const value = page;
  const range = Math.ceil(post.length / countriesPerPage);
  switch (true) {
    case range < 7:
      pattern = [...new Array(range)].map((_, i) => i + 1);
      break;
    case value < 4:
      pattern = [1, 2, 3, 4, 5, "...", range];
      break;
    case value > range - 4:
      pattern = [1, "...", range - 4, range - 3, range - 2, range - 1, range];
      break;
    default:
      pattern = [1, "...", value - 1, value, value + 1, "...", range];
  }
  const lastPageIndex = page * countriesPerPage;
  const firstPageIndex = lastPageIndex - countriesPerPage;
  const currentPageIndex = post.slice(firstPageIndex, lastPageIndex);
  const changeNumber = (n) => {
    if (typeof n === "number" && n > 0 && n <= range) {
      setPage(n);
    }
  };
  const onDelate = (id) => {
    setPost(post.filter((value) => value.id !== id));
  };
  return (
    <Container>
      <Top>
        <Title size={30}>Favorites</Title>
        <Title color={"#696969"}>Ready to jump back in?</Title>
      </Top>
      <Bottom>
        <div>
          {currentPageIndex.map(
            ({ id, img, titles, location, oldcost, cost }) => (
              <Box key={id}>
                <Image>
                  <img width={"100%"} height={"100%"} src={img} alt="" />
                </Image>
                <TitleDiv>
                  <Title font={600} size={16}>
                    {titles} <Button>FOR SALE</Button>
                  </Title>
                  <Title color={"#696969"}>{location}</Title>
                  <Title.Const>{oldcost}</Title.Const>
                  <Title font={600} size={16}>
                    {cost}
                  </Title>
                </TitleDiv>
                <Delate onClick={() => onDelate(id)}>
                  <Trash />
                </Delate>
              </Box>
            )
          )}
        </div>
        <Pagination>
          <Btn disabled={value <= 1} onClick={() => changeNumber(value - 1)}>
            <LeftArrow/>
          </Btn>
          {pattern.map((label) => (
            <Btn
              key={label}
              onClick={() => changeNumber(label)}
            >
              {label}
            </Btn>
          ))}
          <Btn
            disabled={value >= range}
            onClick={() => changeNumber(value + 1)}
          >
            <RightArrow/>
          </Btn>
        </Pagination>
      </Bottom>
    </Container>
  );
};

export default Favorites;
